import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckoutModal from './CheckoutModal';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import {
  selectCartItems,
  selectCartState,
  selectTotalAmount,
  selectTotalQTY,
  setClearCartItems,
  setCloseCart,
  setGetTotals
} from "../CartSlice.js";
import CartCount from "./cart/CartCount";
import CartEmpty from "./cart/CartEmpty";
import CartItem from "./cart/CartItem";




const Cart = () => {
  const stripePromise = loadStripe("pk_test_51QY7kqHOP9yfECqnIyjicC3Ii3qz7h9KEEhBHjRnQFpBT2gQ6cTPJYX91lBlMVV7hBtGuLMeZ7tQtsKFi8ec2E4c00zdS5fP09");

  const [modalIsOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();
  const ifCartState = useSelector(selectCartState);
  const cartItems = useSelector(selectCartItems);
  const totalAmount = useSelector(selectTotalAmount);
  const totalQTY = useSelector(selectTotalQTY);

  console.log(cartItems)

  useEffect(() => {
    dispatch(setGetTotals());
  }, [cartItems, dispatch]);

  const onCartToggle = () => {
    dispatch(setCloseCart({ cartState: false }));
  };

  const onClearCartItems = () => {
    dispatch(setClearCartItems());
  };

  function closeModal() {
    setIsOpen(false);
  }

  const [cartData] = useState({
    userData: JSON.parse(localStorage.getItem("userData")),
    cartInfo: JSON.parse(localStorage.getItem("cart")),
  })

  useEffect(() => {
    console.log("Cart Information:", cartData.cartInfo);
    console.log("User Information:", cartData.userData);
  }, [cartData]);


  return (
    <>
      <div
        className={`fixed top-0 left-0 right-0 bottom-0 blur-effect-theme duration-500 w-full h-screen opacity-100 z-[250] ${
          ifCartState
            ? "opacity-100 visible translate-x-0"
            : "opacity-0 invisible translate-x-full"
        }`}
      >
        <div
          className={`blur-effect-theme bg-[#cecece] shadow-lg duration-500 h-screen max-w-[350px] w-full absolute right-0 ${
            ifCartState
              ? "opacity-100 visible translate-x-0"
              : "opacity-0 invisible translate-x-full"
          }`}
        >
          <CartCount
            totalQTY={totalQTY}
            onCartToggle={onCartToggle}
            onClearCartItems={onClearCartItems}
          />
          {cartItems?.length === 0 ? (
            <CartEmpty onCartToggle={onCartToggle} />
          ) : (
            <div>
              <div className="flex items-start justify-start flex-col gap-y-7 lg:gap-y-5 overflow-y-scroll h-[81vh] scroll-smooth scroll-hidden py-3">
                {cartItems?.map((item, i) => (
                  <CartItem key={i} item={item} />
                ))}
              </div>

              

              {/*checkout*/}

            </div>
          )}
            <Elements stripe={stripePromise}>
              <CheckoutModal
                isOpen={modalIsOpen}
                closeModal={closeModal}
                totalAmount={totalAmount}
                onClearCartItems={onClearCartItems}
                cartItems={cartItems}
              />
            </Elements>
        </div>
      </div>
    </>
  );
};

export default Cart;
